import { Controller } from "@hotwired/stimulus"

import React from "react"
import { render } from "react-dom"

import {
  CHART_COMPONENT,
  chartFormatter,
} from "web/components/Charts/chart-util"
import { isNonEmptyArray } from "web/services/helpers"

export default class ChartController extends Controller {
  static values = {
    type: String,
    data: Array,
    label: String,
    printAsPDF: Boolean,
    includeLegend: Boolean,
    includeXaxisTicks: Boolean,
    singleColour: String,
    dataKeys: Array,
    topLabel: String,
    bottomLabel: String,
  }

  initialize() {
    global.React = React
  }

  connect() {
    const firstItemInData = isNonEmptyArray(this.dataValue) && this.dataValue[0]
    const { unit, kind, format } = firstItemInData || {}
    const formatter = (data) => chartFormatter(data, kind, unit, format)

    const yAxisLabel = this.labelValue
    const ViewComponent = CHART_COMPONENT[this.typeValue]

    render(
      <ViewComponent
        printAsPDF={this.printAsPDFValue}
        data={this.dataValue}
        formatter={formatter}
        yAxisLabel={yAxisLabel}
        includeLegend={this.includeLegendValue}
        includeXaxisTicks={this.includeXaxisTicksValue}
        singleColour={this.singleColourValue}
        dataKeys={this.dataKeysValue}
        topBarLabel={this.topLabelValue}
        bottomBarLabel={this.bottomLabelValue}
      />,
      this.element
    )
  }
}
